/**
 * *************************************
 *  SHADAPPS CONFIDENTIAL
 *  __________________
 *
 *  Created by Vittorio Tauro
 *
 *  2022 (c) ShadApps Srl
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of ShadApps Srl and its suppliers,
 *  if any. The intellectual and technical concepts contained
 *  herein are proprietary to ShadApps Srl.
 *  and its suppliers and may be covered by Italian, European and Foreign Patents,
 *  patents in process, and are protected by trade secret or copyright law.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from ShadApps Srl.
 * *************************************
 * */

// ----------------------------------------------------------------------

function path(root, sublink) {
    return `${root}${sublink}`;
}

const ROOTS_AUTH = '';
const ROOTS_DASHBOARD = '/home';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
    root: ROOTS_AUTH,
    login: path(ROOTS_AUTH, '/login'),
    register: path(ROOTS_AUTH, '/register'),
    loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
    registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
    verify: path(ROOTS_AUTH, '/verify'),
    resetPassword: path(ROOTS_AUTH, '/reset-password'),
    newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
    comingSoon: '/coming-soon',
    maintenance: '/maintenance',
    pricing: '/pricing',
    payment: '/payment',
    about: '/about-us',
    contact: '/contact-us',
    faqs: '/faqs',
    page403: '/403',
    page404: '/404',
    page500: '/500',
    components: '/components',
};

export const PATH_DASHBOARD = {
    root: ROOTS_DASHBOARD,
    users: {
        root: path(ROOTS_DASHBOARD, '/users'),
        new: path(ROOTS_DASHBOARD, '/user/new'),
        list: path(ROOTS_DASHBOARD, '/user/list'),
        cards: path(ROOTS_DASHBOARD, '/user/cards'),
        profile: path(ROOTS_DASHBOARD, '/user/profile'),
        account: path(ROOTS_DASHBOARD, '/user/account'),
        edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
        demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    },
    airplanetypes: {
        root: path(ROOTS_DASHBOARD, '/airplanetypes'),
    },
    companies: {
        root: path(ROOTS_DASHBOARD, '/companies'),
    },
    airports: {
        root: path(ROOTS_DASHBOARD, '/airports'),
    },
    airways: {
        root: path(ROOTS_DASHBOARD, '/airways'),
    },
    attributes: {
        root: path(ROOTS_DASHBOARD, '/attributes'),
    },
    bookings: {
        root: path(ROOTS_DASHBOARD, '/bookings'),
    },
    cities: {
        root: path(ROOTS_DASHBOARD, '/cities'),
    },
    countries: {
        root: path(ROOTS_DASHBOARD, '/countries'),
    },
    flights: {
        root: path(ROOTS_DASHBOARD, '/flights'),
    },
    seats: {
        root: path(ROOTS_DASHBOARD, '/seats'),
    },
    passengers: {
        root: path(ROOTS_DASHBOARD, '/passengers'),
    },
    uploads: {
        root: path(ROOTS_DASHBOARD, '/uploads'),
    },
    cms: {
        root: path(ROOTS_DASHBOARD, '/cms'),
    },
    tokens: {
        root: path(ROOTS_DASHBOARD, '/tokens'),
    },
    inviteCodes: {
        root: path(ROOTS_DASHBOARD, '/invite-codes'),
    },
    pricingPolicies: {
        root: path(ROOTS_DASHBOARD, '/pricingPolicies'),
    },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
